import { useContext } from 'react';
import { NetworkContext } from '../contexts/NetworkContext';

export const useNetwork = () => useContext(NetworkContext);
